import { m } from 'framer-motion';
import styled from 'styled-components';
const Container = styled.div ``;
const Track = styled(m.ul) `
  display: flex;
`;
const SimpleTrackStyles = {
    Container,
    Track,
};
export default SimpleTrackStyles;
